import { __extends } from "tslib";
import { CompositeMethodBase, _Shader_CompositeMethodBase } from './CompositeMethodBase';
/**
 * ShadowMethodBase provides an abstract base method for shadow map methods.
 */
var ShadowMethodBase = /** @class */ (function (_super) {
    __extends(ShadowMethodBase, _super);
    /**
     * Creates a new ShadowMethodBase object.
     * @param castingLight The light used to cast shadows.
     */
    function ShadowMethodBase(castingLight) {
        var _this = _super.call(this, castingLight.shadowMapper) || this;
        _this._castingLight = castingLight;
        return _this;
    }
    Object.defineProperty(ShadowMethodBase.prototype, "castingLight", {
        /**
         * The light casting the shadows.
         */
        get: function () {
            return this._castingLight;
        },
        enumerable: true,
        configurable: true
    });
    return ShadowMethodBase;
}(CompositeMethodBase));
export { ShadowMethodBase };
/**
 * ShadowHardChunk provides the cheapest shadow map method by using a single tap
 * without any filtering.
 */
var _Shader_ShadowMethodBase = /** @class */ (function (_super) {
    __extends(_Shader_ShadowMethodBase, _super);
    /**
     * Creates a new ShadowHardChunk.
     */
    function _Shader_ShadowMethodBase(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    _Shader_ShadowMethodBase.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        this._baseTexture = this._baseChunk.texture;
    };
    return _Shader_ShadowMethodBase;
}(_Shader_CompositeMethodBase));
export { _Shader_ShadowMethodBase };
